import React from "react";

const STATUS_CONFIG = {
  success: {
    title: "Subscription confirmed",
    message:
      "Your subscription is active. Chat access will be linked to your verified account once checkout goes live.",
    accent:
      "border-pl-success/20 bg-[rgba(45,106,79,0.08)] text-pl-success",
  },
  pending: {
    title: "Subscription pending",
    message:
      "We have your request. Access will unlock after payment confirmation in the future server-backed flow.",
    accent:
      "border-pl-warning/20 bg-[rgba(188,108,37,0.08)] text-pl-warning",
  },
  failed: {
    title: "Subscription failed",
    message:
      "The last attempt did not go through. You can retry once the payment gateway is enabled.",
    accent:
      "border-pl-error/20 bg-[rgba(155,34,38,0.08)] text-pl-error",
  },
  already_subscribed: {
    title: "Already subscribed",
    message:
      "This account already has an active subscription. Future checkout should route you directly into chat access.",
    accent:
      "border-pl-info/20 bg-[rgba(43,108,176,0.08)] text-pl-info",
  },
};

const ChatStatusBanner = ({ status }) => {
  const config = STATUS_CONFIG[status];

  if (!config) {
    return null;
  }

  return (
    <section
      aria-live="polite"
      className={`mb-8 rounded-10 border px-5 py-4 shadow-pl-sm ${config.accent}`}
    >
      <p className="text-12 font-semibold uppercase tracking-[0.18em]">
        Mock Checkout State
      </p>
      <h2 className="mt-2 text-18 font-semibold">{config.title}</h2>
      <p className="mt-2 text-14 leading-6 text-pl-text-secondary">
        {config.message}
      </p>
    </section>
  );
};

export default ChatStatusBanner;
